/* eslint-disable @typescript-eslint/no-explicit-any */
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { InitalStateInterface } from './types';

export const AUTH_INITIAL_STATE: InitalStateInterface = {
  data: null,
  fetching: false,
  payload: null,
  token: '',
  errors: [],
};

const authSlice = createSlice({
  name: 'auth',
  initialState: AUTH_INITIAL_STATE,
  reducers: {
    authRequest: (state, action: PayloadAction<any>) => {
      state.fetching = true;
      state.data = action.payload;
      state.payload = null;
      state.token = '';
    },
    authLogin: (state, action: PayloadAction<any>) => {
      state.fetching = false;
      state.errors = [];
      state.payload = action.payload.user;
      state.token = action.payload.token;
    },
    authFailure: (state, action: PayloadAction<any>) => {
      state.fetching = false;
      state.errors = action.payload;
      state.payload = null;
      state.token = '';
    },
    authLogout: state => {
      state.fetching = false;
      state.errors = [];
      state.payload = null;
      state.token = '';
    },
  },
});

export const { authRequest, authLogin, authFailure, authLogout } =
  authSlice.actions;
export const authReducer = authSlice.reducer;
